import type { FC, SVGProps } from 'react';

const CommentTachycardiaIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_15887_825246)">
      <path
        d="M19.1921 24.178C20.6882 15.9494 29.785 10.183 34.48 8.16568C34.6578 8.08928 34.706 7.88098 34.5872 7.73893C32.9341 5.76247 33.202 3.44736 33.6514 2.22924C33.7387 1.99269 33.7943 1.73191 33.6474 1.52096C33.2041 0.884594 31.9577 0.265985 31.2933 0.00280626C28.4894 -0.130756 27.1613 4.54394 26.8661 5.34531C26.571 6.14669 25.9807 5.87956 25.8331 5.74633C25.7264 5.64994 24.5654 3.06958 23.835 1.42434C23.6988 1.1176 23.4142 0.878415 23.0559 0.814256C21.5805 0.550066 20.6243 0.870547 20.0916 1.25523C19.7325 1.51456 19.684 1.96082 19.7741 2.36856L20.5205 5.74633C21.2584 7.88334 19.4875 8.41759 18.7497 7.88334L16.5959 6.15106C16.2718 5.89034 15.8504 5.73707 15.4186 5.77275C13.3198 5.94615 12.78 6.9382 12.7799 7.69776C12.7798 8.00103 12.9509 8.27429 13.1189 8.5367C14.2382 10.2852 13.76 11.9238 13.2202 12.7801C13.1198 12.9394 13.1941 13.1525 13.3854 13.2129C15.3452 13.8319 16.37 14.4403 16.0928 16.6985C15.5396 21.204 17.8639 23.5102 19.1921 24.178Z"
        fill="currentColor"
      />
      <path
        d="M40.303 71.7263C55.0602 68.9215 56.2408 29.654 41.6332 24.3115C36.9188 27.0896 36.5141 32.9486 36.9011 35.5308C37.1613 37.2671 34.1867 37.3152 33.9496 35.6644C32.4149 24.9793 41.1807 20.6163 45.7554 19.7704C47.0541 14.0005 43.5484 10.421 41.6332 9.35252C32.9363 9.7532 23.3244 17.9005 21.9963 25.1129C20.6435 32.4589 17.5199 32.9486 15.7982 32.9931C14.0273 32.8595 14.3225 30.9897 16.2409 30.3219C17.6682 29.825 18.2191 28.2469 18.3993 27.326C18.4399 27.1182 18.321 26.9133 18.123 26.8018C12.5101 23.6414 13.2066 18.985 13.2834 16.626C13.29 16.4237 13.1631 16.2406 12.9632 16.1501L9.88605 14.7576C9.63409 14.6436 9.32823 14.7066 9.1556 14.9081L4.05968 20.8553C3.94746 20.9863 4.00047 21.1807 4.1604 21.2615C13.1394 25.7925 6.63709 32.1113 5.62552 36.7329C2.08174 57.9693 26.571 74.3348 40.303 71.7263Z"
        fill="currentColor"
      />
      <path
        d="M47.9894 50.2142H49.4894V51.7142V68.4285C49.4894 69.8092 50.6087 70.9285 51.9894 70.9285H58.9894C60.3701 70.9285 61.4894 69.8092 61.4894 68.4285V51.7142V50.2142H62.9894H68.9338C70.1733 50.2142 70.8779 48.7961 70.1293 47.8082L55.4856 28.4835L40.8418 47.8083C40.0932 48.7961 40.7979 50.2142 42.0374 50.2142H47.9894Z"
        fill="currentColor"
        stroke="var(--page-bg)"
        strokeWidth="3"
      />
    </g>
    <defs>
      <clipPath id="clip0_15887_825246">
        <rect width="72" height="72" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CommentTachycardiaIcon;
